import HeroSection from "@/components/MIB/HeroSection";
import ProblemSection from "@/components/MIB/ProblemSection";
import HowItWorksSection from "@/components/MIB/HowItWorksSection";
import TeamChangeSection from "@/components/MIB/TeamChangeSection";
import OutcomesSection from "@/components/MIB/OutcomesSection";
import RolloutSection from "@/components/MIB/RolloutSection";
import KeyAstromSection from "@/components/MIB/KeyAstromSection";
import ContactSection from "@/components/MIB/ContactSection";
import { NavbarTheme } from "@/contexts/NavbarThemeContext";

function Mib() {
  return (
    <div className="flex flex-col gap-[60px] bg-white font-inter min-[478px]:gap-[100px] xl:gap-[120px]">
      <NavbarTheme theme="new" />
      <HeroSection />
      <ProblemSection />
      <HowItWorksSection />
      <TeamChangeSection />
      <OutcomesSection />
      <RolloutSection />
      <KeyAstromSection />
      <ContactSection />
    </div>
  );
}

export default Mib;
